// extracted by mini-css-extract-plugin
export default {"container":"Inspection_container__-CdjY","wrapper":"Inspection_wrapper__ZkNT3"};